var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M12 2.86328C17.514 2.86328 22 7.34928 22 12.8633C22 18.3773 17.514 22.8633 12 22.8633C6.486 22.8633 2 18.3773 2 12.8633C2 7.34928 6.486 2.86328 12 2.86328ZM12 0.863281C5.373 0.863281 0 6.23628 0 12.8633C0 19.4903 5.373 24.8633 12 24.8633C18.627 24.8633 24 19.4903 24 12.8633C24 6.23628 18.627 0.863281 12 0.863281ZM13.25 17.8633C13.25 18.5533 12.691 19.1133 12 19.1133C11.311 19.1133 10.75 18.5533 10.75 17.8633C10.75 17.1733 11.311 16.6133 12 16.6133C12.691 16.6133 13.25 17.1733 13.25 17.8633ZM14.643 7.86528C14.035 7.24928 13.128 6.91028 12.092 6.91028C9.912 6.91028 8.502 8.46028 8.502 10.8603H10.513C10.513 9.37428 11.342 8.84728 12.051 8.84728C12.685 8.84728 13.358 9.26828 13.415 10.0733C13.477 10.9203 13.025 11.3503 12.453 11.8943C11.041 13.2373 11.015 13.8873 11.021 15.3623H13.026C13.013 14.6983 13.056 14.1593 13.961 13.1843C14.638 12.4543 15.48 11.5463 15.497 10.1623C15.508 9.23828 15.213 8.44328 14.643 7.86528Z",
    fill: "#255056"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/question-mark.2b2752a0b2de2b87b1455b2f67b69b5c.svg";
export { ForwardRef as ReactComponent };